// extracted by css-extract-rspack-plugin
export default {"modal-link":"O0xUYp","modalLink":"O0xUYp"};